module.exports = __webpack_public_path__ + "img/question_dark.b459b469.png";